export default "__VITE_ASSET__DkpeV0hS__"